module.exports = __webpack_public_path__ + "components/app-buttons/static/ios-e2713a6bceb742a100a0daaefb28f736.svg";